/**
 * Smooth scroll to anchor links with header offset
 * Prevents URL hash changes
 */

class AnchorScroll {
  constructor() {
    this.init();
  }

  init() {
    // Handle anchor links on page load
    this.handleAnchorLinks();

    // Listen for hash changes from browser navigation
    window.addEventListener('popstate', () => {
      if (window.location.hash) {
        this.scrollToAnchor(window.location.hash.substring(1), false);
      }
    });
  }

  handleAnchorLinks() {
    // Select all anchor links that start with #
    document.addEventListener('click', (e) => {
      const anchorLink = e.target.closest('a[href^="#"]');

      if (!anchorLink) return;

      const href = anchorLink.getAttribute('href');

      // Skip if it's just "#" or empty
      if (!href || href === '#') return;

      // Get the target ID (remove the # symbol)
      const targetId = href.substring(1);

      // Prevent default link behavior
      e.preventDefault();

      // Scroll to the target
      this.scrollToAnchor(targetId, true);
    });
  }

  scrollToAnchor(targetId, smooth = true) {
    const targetElement = document.getElementById(targetId);

    if (!targetElement) {
      console.warn(`Anchor target not found: #${targetId}`);
      return;
    }

    // Get header height
    const headerHeight = this.getHeaderHeight();

    console.log(headerHeight)

    // Calculate target position
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset ;
    const offsetPosition = targetPosition - headerHeight - 20;

    // Scroll to position
    window.scrollTo({
      top: offsetPosition,
      behavior: smooth ? 'smooth' : 'auto'
    });
  }

  getHeaderHeight() {
    // Get header height from CSS variable
    const cssHeaderHeight = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height');

    if (cssHeaderHeight && cssHeaderHeight !== '0px') {
      const parsedHeight = parseFloat(cssHeaderHeight);
      if (!isNaN(parsedHeight) && parsedHeight > 0) {
        return parsedHeight;
      }
    }

    // Fallback: directly measure the header element
    const header = document.querySelector('#header-component');
    if (header) {
      const height = header.getBoundingClientRect().height;
      if (height > 0) {
        return height;
      }
    }

    // Last fallback
    return 0;
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AnchorScroll();
  });
} else {
  new AnchorScroll();
}
